import React from "react";
import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import RadialSkills from "./RadialSkills";
import TechLogos from "./TechLogos";

const Skills = () => {
  return (
    <section id="skills" className="relative py-10 md:py-12 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          index="02."
          eyebrow="Skills"
          title="A versatile toolkit for intelligent systems"
          description="Technologies and frameworks I use to design, build, and ship production-grade AI solutions."
        />

        <Reveal>
          <RadialSkills />
        </Reveal>

        <Reveal delay={80} className="mt-10">
          <TechLogos />
        </Reveal>
      </div>
    </section>
  );
};

export default Skills;
